import Unknown from 'Unknown';
import React, { Component } from 'react';

export class PageNotFound extends Component {
  render() {
    return <Unknown />;
  }
}

export default PageNotFound;
